/**
 * UAT-CS-10: single place to resolve a bilingual (en/ar) field for display.
 * Prefers the current UI language; falls back to the other language when the
 * preferred one is empty — bilingual fields only require ONE language to be
 * filled in, so callers must never assume the "current language" side has a
 * value. Use this everywhere survey/question text is rendered (list, details,
 * fill page, reports, exports) instead of an unconditional `language === 'ar' ? ar : en`.
 */
export function getLocalizedText(
  enValue: string | null | undefined,
  arValue: string | null | undefined,
  language: string | null | undefined,
): string {
  const en = (enValue ?? '').trim();
  const ar = (arValue ?? '').trim();
  const preferArabic = String(language ?? '').startsWith('ar');

  if (preferArabic) return ar || en;
  return en || ar;
}

export default getLocalizedText;
